"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DeserializationInfoCache_definitions, _DeserializationInfoCache_complexDeserializationInfo;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMITIVE_ARRAY_DESERIALIZERS = exports.PRIMITIVE_DESERIALIZERS = exports.DeserializationInfoCache = void 0;
class DeserializationInfoCache {
    constructor(definitions) {
        _DeserializationInfoCache_definitions.set(this, void 0);
        _DeserializationInfoCache_complexDeserializationInfo.set(this, new Map());
        __classPrivateFieldSet(this, _DeserializationInfoCache_definitions, new Map(definitions.map((def) => [def.name ?? "", def])), "f");
    }
    /**
     * Gets the deserialization info object for a complex definition (struct or union).
     * If not found in the cache, the deserialization info object will be built (including sub-types)
     * and added to the cache.
     *
     * @param definition Message definition
     * @returns Deserialization info
     */
    getComplexDeserializationInfo(definition) {
        if (definition.aggregatedKind === "module") {
            throw new Error(`Modules are not used in serialization`);
        }
        const cached = __classPrivateFieldGet(this, _DeserializationInfoCache_complexDeserializationInfo, "f").get(definition.name ?? "");
        if (cached) {
            return cached;
        }
        if (definition.aggregatedKind === "union") {
            const switchTypeDeser = exports.PRIMITIVE_DESERIALIZERS.get(definition.switchType);
            const switchTypeLength = typeToByteLength(definition.switchType);
            if (switchTypeDeser == undefined || switchTypeLength == undefined) {
                throw new Error(`Unrecognized primitive type ${definition.switchType} in union ${definition.name ?? "unknown"}`);
            }
            const deserInfo = {
                type: "union",
                ...getHeaderNeeds(definition),
                definition,
                switchTypeDeser,
                switchTypeLength,
            };
            __classPrivateFieldGet(this, _DeserializationInfoCache_complexDeserializationInfo, "f").set(definition.name ?? "", deserInfo);
            return deserInfo;
        }
        const deserInfo = {
            type: "struct",
            ...getHeaderNeeds(definition),
            fields: definition.definitions.reduce((fieldsAccum, fieldDef) => fieldDef.isConstant === true
                ? fieldsAccum
                : fieldsAccum.concat(this.buildFieldDeserInfo(fieldDef)), []),
        };
        __classPrivateFieldGet(this, _DeserializationInfoCache_complexDeserializationInfo, "f").set(definition.name ?? "", deserInfo);
        return deserInfo;
    }
    /**
     * Builds the deserialization info object for a field definition which can be a complex or primitive type.
     *
     * @param definition Field definition
     * @returns Deserialization info
     */
    buildFieldDeserInfo(definition) {
        const { name, type, isComplex, isArray, arrayLengths } = definition;
        if (isComplex === true) {
            let typeDeserInfo = __classPrivateFieldGet(this, _DeserializationInfoCache_complexDeserializationInfo, "f").get(type);
            if (!typeDeserInfo) {
                const fieldDefinition = __classPrivateFieldGet(this, _DeserializationInfoCache_definitions, "f").get(type);
                if (!fieldDefinition) {
                    throw new Error(`Failed to find definition for type ${type}`);
                }
                typeDeserInfo = this.getComplexDeserializationInfo(fieldDefinition);
            }
            return {
                name,
                type,
                typeDeserInfo,
                isArray,
                arrayLengths,
                definitionId: getDefinitionId(definition),
            };
        }
        if (type === "wchar" || type === "wstring") {
            throw new Error(`'wchar' and 'wstring' types are not supported because they are implementation dependent`);
        }
        const deserialize = isArray === true
            ? exports.PRIMITIVE_ARRAY_DESERIALIZERS.get(type)
            : exports.PRIMITIVE_DESERIALIZERS.get(type);
        if (!deserialize) {
            throw new Error(`Unrecognized primitive type ${type}`);
        }
        const typeLength = typeToByteLength(type);
        if (typeLength == undefined) {
            throw new Error(`Unrecognized primitive type ${type}`);
        }
        const fieldDeserInfo = isArray === true
            ? {
                type: "array-primitive",
                deserialize: deserialize,
                typeLength,
            }
            : {
                type: "primitive",
                deserialize: deserialize,
                typeLength,
            };
        return {
            name,
            type,
            typeDeserInfo: fieldDeserInfo,
            isArray,
            arrayLengths,
            definitionId: getDefinitionId(definition),
        };
    }
}
exports.DeserializationInfoCache = DeserializationInfoCache;
_DeserializationInfoCache_definitions = new WeakMap(), _DeserializationInfoCache_complexDeserializationInfo = new WeakMap();
function typeToByteLength(type) {
    switch (type) {
        case "bool":
        case "int8":
        case "uint8":
        case "string":
            return 1;
        case "int16":
        case "uint16":
            return 2;
        case "int32":
        case "uint32":
        case "float32":
            return 4;
        case "int64":
        case "uint64":
        case "float64":
            return 8;
        default:
            return undefined;
    }
}
exports.PRIMITIVE_DESERIALIZERS = new Map([
    ["bool", (reader) => Boolean(reader.int8())],
    ["int8", (reader) => reader.int8()],
    ["uint8", (reader) => reader.uint8()],
    ["int16", (reader) => reader.int16()],
    ["uint16", (reader) => reader.uint16()],
    ["int32", (reader) => reader.int32()],
    ["uint32", (reader) => reader.uint32()],
    ["int64", (reader) => reader.int64()],
    ["uint64", (reader) => reader.uint64()],
    ["float32", (reader) => reader.float32()],
    ["float64", (reader) => reader.float64()],
    ["string", (reader, length) => reader.string(length)],
]);
exports.PRIMITIVE_ARRAY_DESERIALIZERS = new Map([
    ["bool", readBoolArray],
    ["int8", (reader, count) => reader.int8Array(count)],
    ["uint8", (reader, count) => reader.uint8Array(count)],
    ["int16", (reader, count) => reader.int16Array(count)],
    ["uint16", (reader, count) => reader.uint16Array(count)],
    ["int32", (reader, count) => reader.int32Array(count)],
    ["uint32", (reader, count) => reader.uint32Array(count)],
    ["int64", (reader, count) => reader.int64Array(count)],
    ["uint64", (reader, count) => reader.uint64Array(count)],
    ["float32", (reader, count) => reader.float32Array(count)],
    ["float64", (reader, count) => reader.float64Array(count)],
    ["string", readStringArray],
]);
function readBoolArray(reader, count) {
    const array = new Array(count);
    for (let i = 0; i < count; i++) {
        array[i] = Boolean(reader.int8());
    }
    return array;
}
function readStringArray(reader, count) {
    const array = new Array(count);
    for (let i = 0; i < count; i++) {
        array[i] = reader.string();
    }
    return array;
}
function getHeaderNeeds(definition) {
    const { annotations } = definition;
    if (!annotations) {
        return { usesDelimiterHeader: false, usesMemberHeader: false };
    }
    if ("mutable" in annotations) {
        return { usesDelimiterHeader: true, usesMemberHeader: true };
    }
    if ("appendable" in annotations) {
        return { usesDelimiterHeader: true, usesMemberHeader: false };
    }
    return { usesDelimiterHeader: false, usesMemberHeader: false };
}
function getDefinitionId(definition) {
    const { annotations } = definition;
    if (!annotations) {
        return undefined;
    }
    if (!("id" in annotations)) {
        return undefined;
    }
    const id = annotations.id;
    if (id != undefined && id.type === "const-param" && typeof id.value === "number") {
        return id.value;
    }
    return undefined;
}
//# sourceMappingURL=DeserializationInfoCache.js.map